<template>
  <div id="app" class="gamesystem" data-page="gamesystem">
    <div class="gamesystem-wrap">
      <div class="gamesystem-title">游戏系统</div>
      <div class="gamesystem-box">
        <div class="gamesystem-subtitle">连续不断体感弹射动作游戏</div>
        <div class="gamesystem-video">
          <iframe
            id="game_video"
            width="560"
            height="315"
            src=""
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
        <ul class="gamesystem-list__ul">
          <li class="gamesystem-list__li">
            <div
              class="gamesystem-list__collapse gamesystem-list__collapse--skt"
            ></div>
          </li>
          <li class="gamesystem-list__li">
            <div
              class="gamesystem-list__collapse gamesystem-list__collapse--skt"
            ></div>
          </li>
          <li class="gamesystem-list__li">
            <div
              class="gamesystem-list__collapse gamesystem-list__collapse--skt"
            ></div>
          </li>
          <li class="gamesystem-list__li">
            <div
              class="gamesystem-list__collapse gamesystem-list__collapse--skt"
            ></div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { articlenNews } from "@api/index";
import { VUE_APP_API_URL } from "@utils/index";

export default {
  name: "Gamesystem",
  components: {},
  data() {
    return {
      baseUrl: VUE_APP_API_URL
    };
  },
  mounted: function() {
    window.$("#LT_age").remove();
    let that = this;
    that.$("body").on("click", ".gamesystem-list__collapse", function() {
      if (that.$(this).hasClass("slide")) {
        that.$(this).removeClass("slide");
        that
          .$(this)
          .next()
          .slideUp();
      } else {
        that.$(".gamesystem-list__collapse").removeClass("slide");
        that
          .$(".gamesystem-list__collapse")
          .next()
          .slideUp();
        that.$(this).addClass("slide");
        that
          .$(this)
          .next()
          .slideDown();
      }
    });
    that.initData();
  },
  methods: {
    initData() {
      let that = this;
      articlenNews({
        sort: 1,
        class_id: 19,
        page: 0
      }).then(res => {
        var list = res.new_list.map(e => {
          return {
            content: that
              .$("<div>")
              .html(e.detail)
              .text(),
            contentTitle: "",
            imageUrl1: "",
            imageUrl2: "",
            seq: 4,
            tabTitle: e.title
          };
        });
        const topvideo = list.shift();
        var __src = "";
        try {
          __src = topvideo.content
            .match(/src="(.*?)"/gi)[0]
            .replace(/src="(.*?)"/gi, "$1");
        } catch (error) {
          console.log(error);
        }
        that
          .$("#game_video")
          .attr("src", __src.includes("http") ? __src : that.baseUrl + __src);
        var HTML = "";
        list.forEach(function(v) {
          HTML += that.gameListRender(v);
        });
        that.$(".gamesystem-list__ul").html(HTML);
      });
    },
    gameListRender(data) {
      let that = this;
      var gameList =
        '<li class="gamesystem-list__li">\
                <div class="gamesystem-list__collapse" >\
                    <div class="gamesystem-list__collapse-title">' +
        data.tabTitle +
        '</div>\
                </div >\
                <div class="gamesystem-list__info">\
                    ' +
        data.contentTitle +
        "\
                    " +
        data.content +
        '\
                    <ul class="gamesystem-list__info-img-list">\
                        <li class="gamesystem-list__info-img">\
                            <img src="' +
        that.baseUrl +
        data.imageUrl1 +
        '" alt="">\
                        </li>\
                        <li class="gamesystem-list__info-img">\
                            <img src="' +
        that.baseUrl +
        data.imageUrl2 +
        '" alt="">\
                        </li>\
                    </ul>\
                </div>\
            </li>';
      return gameList;
    }
  }
};
</script>
<style scoped></style>
